const errorLocalization = {
  en: {
    error: 'Error',
    code0: 'Unknown error',
    code1: 'Incorrect request',
    code2: 'Wrong login or password',
    code3: 'Access denied',
    code4: 'Login incorrect',
    code5: 'Your contract is inactive',
    code6: 'Your contract is paused',
    code7: 'Channel not found or not allowed',
    code8: 'Error generate URL. Bad parameters',
    code9: 'Need DAY parameter <DDMMYY>',
    code10: 'Need Channel ID',
    code11: 'Another client with your login was logged',
    code12: 'Authentication error',
    code13: 'Your packet was expired',
    code14: 'Unknown API function',
    code15: 'Archive is not available',
    code16: 'Need place to set',
    code17: 'Need name of settings variable',
    code18: 'Incorrect confirmation code',
    code19: 'Current password is wrong',
    code20: 'New password is wrong',
    code21: 'Need value (val) parameter',
    code22: 'This value is not allowed',
    code23: 'Need parameter',
    code24: 'Need parameter <id>',
    code25: 'Need parameter <fileid>',
    code26: 'Need parameter <type>',
    code27: 'Need parameter <query>',
    code29: 'Need parameter <bitrate>',
    code30: 'Service is not available for your account',
    code31: 'Query limit exceeded',
    code32: 'Rule already exist',
    code33: 'Need param ?cmd = hide_channel | show_channel | get_list',
    code34: 'Need param ?cmd = get_user_rates | set_user_rates',
    code35: 'Bad rate value. Allow <show|hide|pass>',
    code36: "Can't find film",
    code37: 'This film already added to favorite list',
    code99: 'System error',
    networkError: 'Network error. Try again later.',
    channelNotSupported:
      'Sorry, your device is not supported this channel stream.',
    contentNotSupport: 'Sorry, your device is not supported this content.',
    archiveUnavaiable4Channel: 'Archive unavaiable for this channel',
    archiveUnavaiable4Date: 'Archive unavaiable for selected time',
    settingNotSave: 'Setting not save',
    appCriticalError: 'Something went wrong. Restarting app...',
  },
  ru: {
    error: 'Ошибка',
    code0: 'Произошла неизвестная ошибка',
    code1: 'Запрос не может быть выполнен',
    code2: 'Логин или пароль введены неверно',
    code3: 'Доступ запрещен',
    code4: 'Логин введён неверно',
    code5: 'Ваш тариф неактивирован',
    code6: 'Проверьте, оплачена ли услуга',
    code7: 'Канал не найден или временно недоступен',
    code8: 'Ошибка ссылки – указаны неверные параметры',
    code9: 'Нужен параметр DAY',
    code10: 'Нужен ID канала',
    code11: 'Вход выполнен с другого устройства',
    code12: 'Ошибка входа в систему',
    code13: 'Срок действия тарифа устёк',
    code14: 'Неизвестная функция API',
    code15: 'Архив временно недоступен',
    code16: 'Необходимо установить в набор',
    code17: 'Нужно название переменной установки',
    code18: 'Неверный код подтверждения',
    code19: 'Текущий пароль введён неверно',
    code20: 'Новый пароль введён неверно',
    code21: 'Необходим параметр val',
    code22: 'Выбранная опция недоступна для использования',
    code23: 'Нужен параметр',
    code24: 'Нужен параметр <id>',
    code25: 'Нужен параметр <fileid>',
    code26: 'Нужен параметр <type>',
    code27: 'Нужен параметр <query>',
    code29: 'Нужен параметр <bitrate>',
    code30: 'Сервис временно недоступен',
    code31: 'Превышен лимит запросов',
    code32: 'Правило уже существует',
    code33: 'Нужен параметр ?cmd = hide_channel | show_channel | get_list',
    code34: 'Нужен параметр ?cmd = get_user_rates | set_user_rates',
    code35: 'Неверное значение рейтинга',
    code36: 'Фильм не найден',
    code37: 'Этот фильм уже добавлен в список избранных',
    code99: 'Системная ошибка',
    networkError: 'Ошибка сети. Повторите попытку позже.',
    channelNotSupported:
      'К сожалению, параметры Вашего устройства не позволяют включить вещание этого канала',
    contentNotSupport:
      'К сожалению, параметры Вашего устройства не позволяют включить этот контент.',
    archiveUnavaiable4Channel: 'Архив недоступен для выбранного канала',
    archiveUnavaiable4Date: 'Архив недоступен для выбранного времени',
    settingNotSave: 'Настройка не сохранена',
    appCriticalError: 'Что-то пошло не так. Приложение будет перезапущено...',
  },
};

export default errorLocalization;
